
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { ClientsCategoriesUpdateRequestType } from "./clientsUpdate.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import { IClientsCategoriesListItem} from '@/entity/clients/clientsCategories.types';

@Component
export default class ClientsCategoriesUpdateForm extends Form {

    id: number | null = null;
    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    color: string | null = null;
    icon: string | null = null;

    getFormData(): ClientsCategoriesUpdateRequestType {
       return{
            id: this.id,
            name: this.name,
            color: this.color,
            icon: this.icon,
       } 
    }

    setFormData(client: IClientsCategoriesListItem): void {
        this.id = client.id;
        this.name = client.name;
        this.color = client.color;
        // console.clear();
        console.log(client);
    }
}
